import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgB1 from './assets/b1.jpg';
import ImgB2 from './assets/b2.jpg';
import ImgB3 from './assets/b3.jpg';
import ImgB4 from './assets/b4.jpg';
import ImgB5 from './assets/b5.jpg';
import ImgB6 from './assets/b6.jpg';
import ImgB7 from './assets/b7.jpg';
import ImgB8 from './assets/b8.jpg';
import ImgSketchHome from './assets/sektch-home.jpg';
import GifB3 from './assets/animated-logo.gif';
import VidB8 from './assets/BRB.mp4';
import ImgSheltertech from '../assets/ShelterTech.png';
import ImgAskdarcel from '../assets/AskDarcel.png';

export default class BeboStreaming extends Component {

    render () {
        return (
          <div className={css.projectPage}>
            <Header
              title='Bebo Streaming Software'
              year='2018 — 2019'
              position='Product Designer & Apparel Design'
            />
            <div className={css.content}>
              <img src={ImgB1} alt='Bebo Streaming Software' />
              <div className={css.text}>
                <p>Bebo streaming software lets Twitch content creators unleash their creativity with a powerful all-in-one production suite. Ground breaking computer vision technology allows any streamer to create professional looking effects triggered in real time by their gameplay with a few clicks of their mouse.</p>
              </div>
              <div className={css.col2}>
                <img src={ImgB2} alt='Bebo Logo' style={{ width:'59%'}} />
                <img src={GifB3} alt='Bebo Animated Logo' style={{ width:'38%', marginLeft:'20px'}} />
              </div>
              <img src={ImgB3} alt='Bebo Identity' style={{ marginTop:'20px'}} />
              <div className={css.text}>
                <p>Bebo’s identity is inspired by the engineering specifications of  early television technology—fitting, as Bebo users see Twitch as the future of TV. Bebo’s bold palette is based on the famous SMPTE colour bars and the iconography and interface appeal to the technical and exacting nature of Twitch broadcasters.</p>
              </div>
              <img src={ImgB4} alt='Bebo Interface' />
              <img  style={{ marginTop:'-5px'}}  src={ImgB5} alt='Bebo Interface' />
              <div className={css.text}>
                <p>Of the 2 million people that broadcast monthly on Twitch, fewer than 25,000 can stream as a full time job—the vast majority don’t have a large enough community to support them. So we approached this problem by giving content creators more ways to engage their audiences and stand out from the competition.</p>
                <p>The first roadblock for a new streamer is the existing ecosystem is split amongst a dozen software programs which means hours spent setting up your stream instead of streaming. We integrated the key tools into one platform—streaming and recording, chat, payments, and bots.</p>
                <p>When Twitch featured our app in an A/B test of their broadcasting tools page, Twitch found that new streamers that used Bebo had a 35% lift in watch time compared to those that didn’t stream with Bebo.</p>
              </div>
              <img src={ImgB6} alt='Bebo Landing Page' />
              <img src={ImgSketchHome} alt='Bebo Sketches' />
              <div className={css.text}>
                <p>The special sauce of Bebo is GameSense, a game-activity driven graphics engine which allows streamers to trigger events based on their gameplay. For the first time, streamers can create live broadcasts on par with television without the need of a team managing the graphics.</p>
              </div>
              <div className={css.aspectRatio}>
                <iframe title='Bebo Game Sense Trailer' width="100%" height="100%" src="https://www.youtube.com/embed/bjpwzpA4sbE?controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <div className={css.aspectRatio}>
                <iframe title='Bebo Ad March 2018' width="100%" height="100%" src="https://www.youtube.com/embed/z0CnphdeUko?controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <div className={css.text}>
                <p>Along with GameSense, we introduced numerous features that our users asked for, including mini-games, collectables, and reward currencies to boost user engagement. Many of our ideas were eventually supported more directly by Twitch via Twitch Extensions.</p>
              </div>
              <div className={css.aspectRatio}>
                <iframe title='Bebo Loot Box Pitch Video' width="100%" height="100%" src="https://www.youtube.com/embed/N4L7qKS6OTg?controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <div className={css.aspectRatio}>
                <video autoplay="autoplay" loop poster={ImgB8}>
                  <source src={VidB8} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className={css.text}>
                <p>My role on this project varied from project management to product design to apparel design. I art directed and managed a team of animators and motion designers to work on many of the overlays and graphics that were built into the app, and I worked alongside our other in-house product designer on the interface and design system for the app itself.</p>
                <p>The most surprising and fun design project was the creation of a lifestyle apparel brand as a marketing strategy. Brands endemic to gaming understand that gaming is a lifestyle, complete with its own celebrities, language, and fashion, and Twitch is one of the few places gamers congregate on screen. We took advantage of the visual nature of Twitch to spread brand awareness by creating an apparel and accessory line that our users, and some non-users, were proud to wear on and off camera.</p>
              </div>
              <img src={ImgB7} alt='Bebo Apparel' />
              <div className={css.text}>
                <p>Want to know more about the design process for this project? <a href="https://docs.google.com/presentation/d/e/2PACX-1vQrDwQii_lshklmKsDzIMap4SM5H5g_GFV4vUKlumOmJ5LQNJ9unV6tTUxrYTUrGye-msCw3Twj8psQ/pub?start=false&loop=false&delayms=10000" target="_blank" rel="noopener noreferrer">View the case study here.</a></p>
              </div>
            </div>
            <div className={css.moreWork}>
              <header>More Projects</header>
                <ul className={css.moreWorkList}>
                  <ProjectItem
                    title='Sheltertech'
                    description='Solving the biggest tech challenges faced by the homeless'
                    position='Co-Founder / Design & Product Lead'
                    img={ImgSheltertech}
                    link='Sheltertech'
                  />
                  <ProjectItem
                    title='AskDarcel'
                    description='Housing and human services directory'
                    position='Product Manager / Product Designer'
                    img={ImgAskdarcel}
                    link='Askdarcel'
                  />
                </ul>
            </div>
          </div>
        )
     }
  }
